// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://gravity.group-cdn.one/v5.36.0/css/brands/one-rebrand.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
}

html {
  font-size: 16px;
}

body {
  background-color: white;
  font-family: 'Plus Jakarta Sans', 'Open Sans', Arial, sans-serif;
  font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/shared/styles/gravity-global.css"],"names":[],"mappings":"AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,gEAAgE;EAChE,gBAAgB;AAClB","sourcesContent":["@import url('https://gravity.group-cdn.one/v5.36.0/css/brands/one-rebrand.css');\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n}\n\nhtml {\n  font-size: 16px;\n}\n\nbody {\n  background-color: white;\n  font-family: 'Plus Jakarta Sans', 'Open Sans', Arial, sans-serif;\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
